import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";

const EditSubscription = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [subscriptionType, setSubscriptionType] = React.useState("default");

    const handleTypeChange = (event: SelectChangeEvent) => {
        setSubscriptionType(event.target.value as string);
    };

    const isAddSubscription = location.pathname === "/subscriptions/add";

    return (
        <>
            <div className="main_title">
                <h1>{isAddSubscription ? "Add" : "Edit"} Subscription</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/subscriptions")}>
                        Manage Subscriptions
                    </button>{" "}
                    - {isAddSubscription ? "Add" : "Edit"} Subscription
                </p>
            </div>

            <div className="cards">
                <div className="form">
                    <div className="gap_p">
                        {/* Subscription Type */}
                        <div className="control_group w_33">
                            <label htmlFor="subscription-type">Subscription Type</label>
                            <Select
                                id="subscription-type"
                                fullWidth
                                value={subscriptionType}
                                onChange={handleTypeChange}
                            >
                                <MenuItem disabled value="default">
                                    Select Type
                                </MenuItem>
                                <MenuItem value="Freemium">Freemium</MenuItem>
                                <MenuItem value="Premium">Premium</MenuItem>
                            </Select>
                        </div>

                        {/* Subscription Name */}
                        <div className="control_group w_33">
                            <label htmlFor="subscription-name">Subscription Name</label>
                            <TextField
                                id="subscription-name"
                                placeholder="Enter Plan Name"
                                hiddenLabel
                                fullWidth
                            />
                        </div>

                        {/* Price */}
                        <div className="control_group w_33">
                            <label htmlFor="price">Price</label>
                            <TextField
                                id="price"
                                type="text"
                                placeholder="Enter Price (e.g. $9.99 or Free)"
                                hiddenLabel
                                fullWidth
                            />
                        </div>

                        {/* Validity */}
                        <div className="control_group w_33">
                            <label htmlFor="validity">Validity</label>
                            <TextField
                                id="validity"
                                type="text"
                                placeholder="Enter Validity (e.g. 30 Days, 1 Year)"
                                hiddenLabel
                                fullWidth
                            />
                        </div>

                        {/* Benefits */}
                        <div className="control_group w_100">
                            <label htmlFor="benefits">Benefits</label>
                            <TextField
                                id="benefits"
                                placeholder="List benefits separated by commas or new lines"
                                hiddenLabel
                                fullWidth
                                multiline
                                minRows={3}
                            />
                        </div>
                    </div>

                    <div className="form_btn">
                        <Button
                            variant="contained"
                            color="primary"
                            className="btn btn_primary"
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditSubscription;
